/**
 * Travel point programs from the API may be either:
 * - { program, points, points_per_value }
 * - Go-style map JSON: [{ Key: "program", Value: "..." }, ...]
 */

function normalizeTravelProgramToForm(p) {
  if (!p) {
    return { program: "", points: "", points_per_value: "" };
  }

  if (typeof p === "object" && !Array.isArray(p)) {
    if (p.program !== undefined || p.points !== undefined || p.points_per_value !== undefined) {
      return {
        program: p.program != null ? String(p.program) : "",
        points: p.points != null ? String(p.points) : "",
        points_per_value: p.points_per_value != null ? String(p.points_per_value) : "",
      };
    }
  }

  if (Array.isArray(p)) {
    const o = { program: "", points: "", points_per_value: "" };
    for (const pair of p) {
      const k = pair?.Key ?? pair?.key;
      const v = pair?.Value ?? pair?.value;
      if (k === "program") o.program = String(v ?? "");
      if (k === "points") o.points = v != null ? String(v) : "";
      if (k === "points_per_value") o.points_per_value = v != null ? String(v) : "";
    }
    return o;
  }

  return { program: "", points: "", points_per_value: "" };
}

/** Maps API `travel_points_programs` to form state rows for TravelPointsDialog */
export function normalizeTravelPointsProgramsForForm(programs) {
  if (!Array.isArray(programs) || programs.length === 0) {
    return [{ program: "", points: "", points_per_value: "" }];
  }
  return programs.map(normalizeTravelProgramToForm);
}

/** Single program row for display (table badges) */
export function getTravelProgramDisplayRow(p) {
  const f = normalizeTravelProgramToForm(p);
  return {
    program: f.program,
    points: parseFloat(f.points) || 0,
    points_per_value: parseFloat(f.points_per_value) || 0,
  };
}